import { createScheduledActions, SB } from '@play-co/replicant';
import { stateSchema } from '../State';
import computedProperties from '../computedProperties';
import messages from '../messages';
import { PetChatbot } from '../buruburu/petChatbot';
import { Inventory } from '../buruburu/inventory';
import { Pet } from '../buruburu/pet';
import { fateToString } from '../buruburu/fate/fate.utils';
import { getLocalTimezone } from '../utils/time';

const scheduledActions = createScheduledActions(
  stateSchema,
  {
    triggerOnGameEnd: SB.unknown(),
    ...PetChatbot.scheduledActions.schema,
    ...Inventory.scheduledActions.schema,
  },
  { computedProperties, messages },
);

export default scheduledActions({
  triggerOnGameEnd: async (state, _, api) => {
    const now = api.date.now();
    const timeZone = getLocalTimezone(state);
    const {
      getAllAttributeValues,
      getAllStatusEffects,
      getPetState,
      getNextPetState,
    } = Pet.getters(state);

    api.sendAnalyticsEvents([
      {
        eventType: 'DebugGameEnd',
        eventProperties: {
          fate: state.fate,
          attributes: getAllAttributeValues(now),
          effects: getAllStatusEffects(now),
          schedule: fateToString(state.fate.schedule, timeZone),
          state: getPetState(now, false),
          nextState: getNextPetState(now),
        },
      },
    ]);
    const chatbot = require('../chatbot').default;
    await chatbot.events.onGameEnd(state, null, api, true);
  },

  ...PetChatbot.scheduledActions.actions,
  ...Inventory.scheduledActions.actions,
});
